export const SET_CUSTOMER_REPORTS_LOADING = 'SET_CUSTOMER_REPORTS_LOADING';
export const GET_CUSTOMER_REPORTS_SUCCESS = 'GET_CUSTOMER_REPORTS_SUCCESS';
export const GET_CUSTOMER_REPORTS_ERROR = 'GET_CUSTOMER_REPORTS_ERROR';
